import {ViewerEnd} from '../../../../../../graphql/generated/types';
import {createQueryClient} from '../../../../../../reactQuery/createQueryClient';
import {useViewerEndQuery} from '../../../../../../wrapper/viewerWrapper';

export function updateCacheIsLikeOn({
  seriesId,
  productId,
  isLikeOn,
}: {
  seriesId: number;
  productId: number;
  isLikeOn: boolean;
}) {
  const queryClient = createQueryClient();
  queryClient.setQueryData(
    useViewerEndQuery.getKey({seriesId, productId}),
    (prevData: ViewerEnd | undefined) => {
      if (!prevData) {
        return prevData;
      }
      return {
        ...prevData,
        likeOn: isLikeOn,
      };
    }
  );
}
